module.exports = __webpack_public_path__ + "img/5.e2be0420.png";